import { frontendURL } from 'dashboard/helper/URLHelper';
import AppointmentsCalendar from './pages/AppointmentsCalendar.vue';

const appointmentsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/appointments'),
      name: 'appointments_calendar',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: AppointmentsCalendar,
    },
  ],
};

export default appointmentsRoutes;
